module.exports = __webpack_public_path__ + "static/icons/icon-dropdown-75c9163e633f0ba47eae872eab49b242.svg";